@use '@design/design-tokens/typography/typography' as *;

.root {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
}

.flexRowWrapper {
  display: flex;
  flex-direction: row;
  gap: 4px;
}

.currencyLabel {
  display: flex;
  flex-direction: row;
  position: relative;
  top: 2px;
  @include typography-v2-body-xs;
}
